if (!customElements.get('predictive-search')) {
customElements.define('predictive-search', class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.placeholderContent = this.querySelector('[data-search-placeholder]')
    this.clear = this.querySelector('[data-search-clear]')
  }

  connectedCallback() {
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 100).bind(this));

    this.initSearchInput()
    this.initClear()
  }

  initSearchInput () {
    this.input.setAttribute('autocomplete', 'off')

    this.input.addEventListener('focus', () => {
      this.placeholderContent.classList.remove('hide');
      this.placeholderContent.style.display = 'block';
    });

    this.addEventListener('blur', () => {
      this.placeholderContent.classList.add('hide');
      this.placeholderContent.style.display = 'none';
      this.predictiveSearchResults.style.display = 'none';
    })

    document.addEventListener('click', (event) => {
      if (event.target.closest('predictive-search')) { return }
      this.closeSearch()
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') { return }
      if (document.activeElement.closest('predictive-search')) { return }
      this.closeSearch()
    })

    return this.input
  }

    closeSearch () {
      this.predictiveSearchResults.style.display = 'none';
      this.placeholderContent.classList.add('hide');
      this.placeholderContent.style.display = 'none';
    }

    clearSearch () {
      this.predictiveSearchResults.style.display = 'none';
      this.placeholderContent.classList.remove('hide');
      this.placeholderContent.style.display = 'block';
    }

    initClear () {
      this.clear.addEventListener('click', () => {
        this.input.value = ''
        this.clearSearch();
      })
    }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.clearSearch();
      return;
    }

    this.getSearchResults(searchTerm);
    this.placeholderContent.style.display = 'none';
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product,page,query`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }

      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
    })
    .catch((error) => {
      this.close();
      throw error;
    });
}

  open() {
    this.predictiveSearchResults.style.display = 'block';
    const viewAllButton = this.predictiveSearchResults.querySelector('[data-predictive-search-view-all]');
    // document.querySelector('mobile-nav').classList.toggle('active')
    // trapFocus.close();
    // scrollLock.unlock();
    // document.body.classList.remove('nav-open');
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
});
}
